// src/connectors/components/ProviderIcon.jsx
//
// Small colored initials chip for a connector provider (GitHub, Jira,
// Salesforce, ...). Per the requirements doc's open question §7.1: ships
// with initials rather than real provider logos for v1, to avoid a logo
// sourcing/licensing detour — matches the pattern already used for the
// topbar's Account switcher (`orion-mark22`).

import PropTypes from "prop-types";

export default function ProviderIcon({ initials, size = 32 }) {
  return (
    <div
      className="flex items-center justify-center rounded-lg bg-brand-100 text-brand-700 font-bold shrink-0"
      style={{ width: size, height: size, fontSize: Math.round(size * 0.34) }}
    >
      {initials}
    </div>
  );
}

ProviderIcon.propTypes = {
  initials: PropTypes.string.isRequired,
  size: PropTypes.number,
};
